function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3E364A",
  d: "M1306.907 1L.286 755.378 754.664 2062l1306.622-754.378z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M724.5 1276c-68.76 0-124.5 55.74-124.5 124.5 0 68.76 55.74 124.5 124.5 124.5 68.76 0 124.5-55.74 124.5-124.5 0-68.76-55.74-124.5-124.5-124.5zm-249 0c-68.76 0-124.5 55.74-124.5 124.5 0 68.76 55.74 124.5 124.5 124.5 68.76 0 124.5-55.74 124.5-124.5 0-68.76-55.74-124.5-124.5-124.5zm249-249c-68.76 0-124.5 55.74-124.5 124.5 0 68.76 55.74 124.5 124.5 124.5 68.76 0 124.5-55.74 124.5-124.5 0-68.76-55.74-124.5-124.5-124.5zm-249 0c-68.76 0-124.5 55.74-124.5 124.5 0 68.76 55.74 124.5 124.5 124.5 68.76 0 124.5-55.74 124.5-124.5 0-68.76-55.74-124.5-124.5-124.5z",
  fill: "#66656C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M399.742 1838.005c248.473 66.647 503.9-81.062 570.51-329.916l.199-.74L70.651 1266l-.198.74c-65.945 246.366 77.89 499.504 321.865 569.209l7.424 2.056z",
  fill: "#FEFAC7"
}));

const SvgShapesContact = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2063,
    height: 2063,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShapesContact, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shapes-contact.6bbbaccb.svg";
export { ForwardRef as ReactComponent };